import {useMemo, useState} from 'react'
import ActionButtons from '../../../components/pages/listActionButtons'
import {EditIcon, PlusIcon, TrashIcon} from '../../../icons'
import {envConfig} from '../../../utils/env'
import SelectedActions from '../../core/filters/SelectedActions'
import Table from '../../core/table'
import {colors} from '../../../utils/colors'

const {isReadOnlyModeEnabled} = envConfig

const PhoneCallTemplatesTable = ({phoneCallTemplates, text, isDarkMode, voicesList, isAddBtnDisabled, onNavigateToEditPage, onPrepareToDelete}) => {
    const [checkedTemplateIds, setCheckedTemplateIds] = useState([])
    const getVoiceDisplayName = voiceShortName => voicesList?.find(voice => voice?.value === voiceShortName)?.label

    const tableHeader = [
        {
            label: text.name,
            className: 'min-width',
            sorting: {
                asc: {
                    key: 'name_asc',
                    field: ['name']
                },
                desc: {
                    key: 'name_desc',
                    field: ['name']
                }
            }
        },
        {
            label: text.voice,
            className: 'min-width-250',
            sorting: {
                asc: {
                    key: 'voice_asc',
                    field: ['voice']
                },
                desc: {
                    key: 'voice_desc',
                    field: ['voice']
                }
            }
        },
        {
            label: text.locale,
            className: 'min-width',
            sorting: {
                asc: {
                    key: 'locale_asc',
                    field: ['locale']
                },
                desc: {
                    key: 'locale_desc',
                    field: ['locale']
                }
            }
        },
        {
            label: '',
            className: 'min-width'
        }
    ]

    const tbodyData = phoneCallTemplates.map(item => [
        <span className="min-width ellipsed-table-row" key={`name-${item?.id}`} title={item?.name}>
            {item?.name || '-'}
        </span>,
        <span className="min-width-250 ellipsed-table-row" key={`voice-${item?.id}`} title={getVoiceDisplayName(item?.voice)}>
            {getVoiceDisplayName(item?.voice) || '-'}
        </span>,
        <span className="min-width" key={`locale-${item?.id}`}>
            {item?.locale || '-'}
        </span>,
        <span className='flex-1 justify-content-flex-end' key={`actions-${item?.id}`}>
            <ActionButtons onEdit={() => onNavigateToEditPage(item?.id)} onDelete={() => onPrepareToDelete(item?.id)}/>
        </span>
    ])

    const actions = useMemo(() => [
        {
            type: 'button',
            label: text.new,
            icon: <PlusIcon stroke={colors.colorMuted}/>,
            className: 'responsive-add-button',
            disabled: isReadOnlyModeEnabled || phoneCallTemplates?.length === 1 || isAddBtnDisabled
        },
        {
            type: 'button',
            label: text.edit,
            icon: <EditIcon />,
            disabled: isReadOnlyModeEnabled || checkedTemplateIds?.length !== 1,
            onClick: () => onNavigateToEditPage(checkedTemplateIds?.[0])
        },
        {
            type: 'button',
            label: text.delete,
            className: 'outline-red',
            icon: <TrashIcon />,
            disabled: isReadOnlyModeEnabled || checkedTemplateIds?.length !== 1,
            onClick: () => onPrepareToDelete(checkedTemplateIds?.[0])
        }
    ], [text, isReadOnlyModeEnabled, checkedTemplateIds])

    return (
        <>
            <div className='search-filter-actions'>
                <SelectedActions isDarkMode={isDarkMode} actions={actions}/>
            </div>

            <Table
                tableHeader={tableHeader}
                tbodyData={tbodyData}
                data={phoneCallTemplates}
                identificator='id'
                inputName='id'
                selectedData={checkedTemplateIds}
                setSelectedData={(checkedIds) => setCheckedTemplateIds(checkedIds)}
                hasCheckbox
                originalData={phoneCallTemplates}
                isSortingEnabled={false}
            />
        </>
    )
}

export default PhoneCallTemplatesTable
